import type { QuestionTypeId } from './types'

/**
 * Left “type” tiles for the question sidebar list (Figma 4838:7469 — 44×44, radius 10, pastel tile + colored glyph).
 */
export interface QuestionListIconTileStyle {
  readonly tileBg: string
  readonly iconColor: string
}

const TILES: Readonly<Record<QuestionTypeId, QuestionListIconTileStyle>> = {
  /** Figma `5062:6983` */
  MULTIPLE_CHOICE: { tileBg: '#eaf3ff', iconColor: '#008cd0' },
  /** Figma `5062:6992` */
  PICTURE_CHOICE: { tileBg: '#fef3e2', iconColor: '#e65100' },
  /** Figma `5062:7007` */
  SHORT_TEXT: { tileBg: '#fae3ed', iconColor: '#c2185b' },
  /** Figma `5062:7021` */
  LONG_TEXT: { tileBg: '#ede9ff', iconColor: '#5e35b1' },
  /** Figma `5062:7030` */
  YES_NO: { tileBg: '#d3f1ff', iconColor: '#00838f' },
  /** Figma `5062:6999` */
  CHECKBOX: { tileBg: '#e8f8f0', iconColor: '#2e7d32' },
  /** Figma `5062:7039` */
  DATE: { tileBg: '#dcfaca', iconColor: '#33691e' },
  /** Figma `5062:7047` */
  RATING: { tileBg: '#fff3cd', iconColor: '#f57c00' },
  /** Figma `5062:7056` */
  RANKING: { tileBg: '#f8e8ee', iconColor: '#c62828' },
  /** Figma `5062:7065` */
  DROPDOWN: { tileBg: '#fbd89d', iconColor: '#78350f' },
  /** Figma `5062:7074` */
  LIKERT: { tileBg: '#fae6dc', iconColor: '#bf360c' },
  /** Figma `5062:7083` */
  SLIDER: { tileBg: '#e6f4fb', iconColor: '#008cd0' },
  VIDEO: { tileBg: '#ede9ff', iconColor: '#5e35b1' },
}

const FALLBACK: QuestionListIconTileStyle = { tileBg: '#eaf3ff', iconColor: '#008cd0' }

export function questionListIconTile(type: QuestionTypeId): QuestionListIconTileStyle {
  return TILES[type] ?? FALLBACK
}
